import { render, staticRenderFns } from "./EstablishmentAllMessage.vue?vue&type=template&id=84dc4806&"
import script from "./EstablishmentAllMessage.vue?vue&type=script&lang=js&"
export * from "./EstablishmentAllMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EstablishmentAllMessage.vue"
export default component.exports